export default {
  loading: 'Loading...',
  'no-update': 'Already the latest version',
  'load-more': 'Load More',
  'copy-success': 'Copy Successfully',
  'invalid-url': 'Invalid Url',
  'download-unavailable': 'The download link is temporarily unavailable',
  dicePopular: 'The most popular dice game',
  indianLottery: 'Indian official lottery',
  jackpot: 'JACKPOT',
  label: {
    filter: 'Filter',
  },
  home: {
    downloadBanner: {
      title: 'Rupiibet APP',
      subtitle: 'Give you a new experience',
      download: 'Download app',
      close: 'Close download banner',
    },
    tab: {
      home: 'Home',
      result: 'Result',
      casino: 'Casino',
      scratch: 'Scratch',
      scratchOff: 'Scratch Off',
      referral: 'Referral',
      me: 'Me',
      live: 'Live',
      liveCasino: 'Live Casino',
      sports: 'Sports',
      lottery: 'Lottery',
      promotions: 'Promotions',
      invite: 'Invite',
      wallet: 'Wallet',
      proxyhome: 'Agent',
      chat: 'Chat',
      earnmoney: 'Earn Money',
      games: 'Games',
    },
    scratch: {
      title: 'Scratch',
      free: 'FREE',
    },
    kerala: {
      title: 'Kerala State Lottery',
      no: 'NO.',
      lastResult: 'Last Jackpot Outcome',
    },
    digit: {
      title: '3 Digit Game',
      booking: 'Time for Next Booking',
      ticket: 'Ticket',
      price: 'Ticket Price',
      lastResult: 'Last Draw Outcome',
      drawTime: 'Next Draw Time',
    },
    dice: {
      title: 'Dice Game',
      play: 'Play Now',
    },
    color: {
      title: 'Color Prediction',
    },
    matka: {
      bid: 'BID',
      win: 'WIN',
      OPEN: 'OPEN',
      CLOSE: 'CLOSE',
      open: 'Open',
      close: 'Close',
      title: 'Satta Matka',
    },
    'live-casino': {
      title: 'Live Casino',
    },
    car: {
      title: 'Quick Race',
      min: 'min',
      text: 'Next draw starts in',
    },
    tip: {
      closed: '{{name}} is closed now, please choose next game',
      copied: 'Copy successfully, please share with friends',
    },
    label: {
      menu: 'Menu',
      viewAll: 'View All',
      buyNow: 'Buy Now',
      'lucky-spin': 'Lucky Spin',
      rebate: 'Rebate',
      'free-lottery': 'Free Lottery',
      referral: 'Referral',
      'refer-friend': 'Refer Friend',
      agent: 'Agent',
      biggestWins: 'Biggest Wins',
      jackpotGames: 'Jackpot Games',
      onlineUser: '{{number}} users playing',
      popularGame: 'The most popular game',
      provedores: 'Provedores',
      allGames: 'All Games',
      more: 'More',
      days: 'Days',
      hours: 'Hours',
      minutes: 'Minutes',
      seconds: 'Seconds',
      total: 'Total',
      bet: 'Bet',
      online: 'Online',
      winningAmount: 'Winning Amount',
      imgFail: 'Image failed to load',
      partners: 'Trusted Sponsors & Partners Of',
      pays: 'Available payment methods',
      social: 'Social Networks',
      licenses: 'Licenses',
      promotions: 'Promotions',
      invite: 'Invite',
      agency: 'Agency',
      luckySpin: 'Lucky Spin',
      chat: 'Service',
      all: 'All',
      availOutcomes: '{{count}} Available Outcomes',
      downText: 'Add to Desktop',
      aviator: 'Aviator',
      cricket: 'Cricket',
      slots: 'Slots',
      spin: 'Spin',
      ipl: 'IPL 2025',
      registerAndDownload: 'Register and download',
      earn: 'Earn Money',
      rechargeWeekCard: 'Go buy',
    },
    luckyspin: {
      add: 'Add',
      spin: 'SPIN',
      won: 'Won',
      winner: 'Big Winners',
      mySpin: 'My Spin',
    },
    title: {
      scratchOff: 'Scratch Off',
      casino: 'Casino',
      live: 'Live',
      sports: 'Sports',
      lottery: 'Lottery',
      scratch: 'Scratch',
      servertime: 'Server Uptime Days',
      winningInformation: 'Winning Information',
      todayEarningsChart: "Today's earnings chart",
    },
    faq: {
      title: 'RUPIIBET FAQ',
      help: 'Help',
      parimatch: 'Rupiibet',
      info: 'Info',
      safeQuestion: 'How to watch a cricket match live?',
      safeAnswer:
        'Rupiibet provides broadcasting of various cricket tournaments onour website and a live cricket app - one of the best online cricketbetting apps available on the market. You can watch online cricketgames and make your live bets. Enjoy live betting on cricket on Paimatch! Use our live cricket betting tips and live odds cricket to win!',
      trustedQuestion: 'Which site is best for live cricket streaming?',
      trustedAnswer:
        'Rupiibet is one of the best online cricket betting sites where you can watch live cricket streaming and enjoy live cricket betting online with the best online betting rate out there!',
      mobileQuestion: 'How to watch live cricket match on mobile?',
      mobileAnswer:
        'The easiest solution is to download a user-friendly Rupiibet application, which is compatible with iOS and Android-based devices. Download the app from our website and bet live cricket is everywhere in the world!',
      betQuestion: 'How to bet on cricket in Rupiibet?',
      betAnswer:
        'Step 1: Create an account on Rupiibet.\nStep 2: Make a deposit into your account.\nStep 3: Place a bet on Rupiibet.\nStep 4: Confirm your account.\nStep 5: Withdraw your funds. Navigate to the My Account menu in the upper-right corner of your screen.',
      liveQuestion: 'How do you bet on a live match?',
      liveAnswer:
        'Live betting means placing bets when the match has already started.The odds are constantly adjusted during the game because you can see how well players are performing and which team scores more easily as the game progresses.',
      playQuestion: 'How to play cricket betting online?',
      playAnswer:
        'Open the cricket betting page on Rupiibet.\nCreate an account or log in.\nPlace a deposit.\nChoose the game that you want to place bet on.\nFind the markets and odds that you like the most.\nPlace your bet.\nWait till the game ends and see if your bet won.',
      safeIndiaQuestion: 'Is Rupiibet safe in India?',
      safeIndiaAnswer:
        'Yes, Rupiibet withdrawals are safe in India. Players have various options to utilize the deposit methods to withdraw their winnings. These payment methods are encrypted and secure, ensuring reliability and quickness. While withdrawal times may vary depending on the chosen method, they are quite speedy.',
      trustedSiteQuestion: 'Is Rupiibet trusted?',
      trustedSiteAnswer:
        'Rupiibet is a trustworthy online sports betting and casino site, providing users with an extensive range of sports, events, and casino games. The site is easily accessible via a user-friendly interface, mobile app, and multiple payment options, and is well-known for delivering a secure and equitable gaming experience.',
      // safeQuestion: '❓ Is Rupiibet safe in India?',
      // safeAnswer:
      //   '🐱 Yes, Rupiibet withdrawals are safe in India. Players have various options to utilize the deposit methods to withdraw their winnings. These payment methods are encrypted and secure, ensuring reliability and quickness. While withdrawal times may vary depending on the chosen method, they are quite speedy.',
      // trustedAnswer:
      //   '🐱 Rupiibet is a trustworthy online sports betting and casino site, providing users with an extensive range of sports, events, and casino games. The site is easily accessible via a user-friendly interface, mobile app, and multiple payment options, and is well-known for delivering a secure and equitable gaming experience.',
    },
  },
  casino: {
    sortby: 'Sort by',
    categories: 'Categories',
    popular: 'Popular',
    all: 'All',
    lobby: 'Lobby',
  },
  me: {
    label: {
      rechargeRecord: 'Recharge records',
      withdrawRecord: 'Withdrawal records',
      check: 'Check',
    },
    webview: {
      vip: 'Member Center',
    },
    new: 'NEW',
    user: {
      userId: 'User ID',
      moreExciting: 'More exciting after logging in',
      login: 'Log in',
      loginUpper: 'LOGIN',
      uid: 'UID:',
      lastLogin: 'Last login:',
    },
    money: {
      totalWallet: 'Total Wallet',
      myWallet: 'My Wallet',
      cashBalance: 'Cash Balance',
      withdrawAmount: 'Withdrawable Amount',
      totalBalance: 'Total balance',
      wallet: 'Wallet',
      recharge: 'Recharge',
      withdraw: 'Withdraw',
    },
    vip: {
      recharge: 'Recharge',
      move: 'more to reach level',
    },
    bottom: {
      recharge: 'Recharge',
      withdraw: 'Withdraw',
      transfer: 'Transfer',
      proxy: 'Agency Center',
      logout: 'LOG OUT',
      resultHistory: 'My History',
      myBets: 'My Bets',
      myTransactions: 'My Transactions',
      commission: 'My Commission',
      notify: 'Notifications',
      lang: 'Languages',
      customer: 'Customer Service',
      contactCustomer: 'Contact customer service',
      update: 'Update',
      password: 'Password',
      gifCode: 'Gift Code',
    },
    language: {
      switch: 'Switch Language',
      english: 'English',
    },
    tip: {
      cashTitle: 'Cash Balance:',
      cashContent:
        '"Cash balance" refers to the actual cash funds available in your account that can be used for betting or other transactions.',
      withdrawTitle: 'Withdrawable Amount:',
      withdrawContent:
        '"Withdrawable amount" is the portion of your cash balance that can be withdrawn from your account. It represents the money that has met the wagering requirements, which need to be fulfilled before the funds can be withdrawn.',
      dailyRewards: 'Exciting rewards await, act now!',
      bonus: 'Win <0>free</0> prizes, claim your reward now!',
      anyquery: 'For any queries and complaints please email us',
    },
  },
  login: {
    label: {
      login: 'LOG IN',
      register: 'SIGN UP',
    },
  },
  invitation: {
    title: {
      singUp: 'Free lottery tickets',
    },
    label: {
      claim: 'Claim your Ticket',
    },
    home: {
      income: 'Income',
      count: 'Count',
      cumulativeIncome: 'Cumulative income',
      totalInvitedCount: 'Total Invited Count',
      inviteGet: 'Invite {{count}} friends to get:',
    },
  },
  push: {
    mainText: 'This website would like to send you awesome updates and offers!',
    secText: 'Notifications can be turned off anytime from browser settings.',
    allow: 'Allow',
    block: "Don't Allow",
  },
  promotionsV2: {
    bonus: 'Bonus',
    reward: 'Reward',
    promotion: 'Promotions',
    history: 'History',
    climb: 'Climb',
    receive: 'Receive',
    received: 'Received',
    expired: 'Expired',
    joined: '{{num}} Joined',
    join: 'Join to win',
    claimTime: 'Claim Time',
    depositAmount: 'Deposit Amount',
    bonusAmount: 'Bonus Amount',
    status: 'Status',
    congratulations: 'Congratulations !',
    getBonus: 'Get Bonus',
    claimNow: 'Claim Now',
    taskList: 'Task List',
    remainTime: 'Remaining Time',
    joinNow: 'Join Now',
    rules: 'Event Rules',
    vipLevel: 'VIP Level',
    rechargeAmount: 'Recharge Amount',
    withdrawAmount: 'Withdraw Amount',
    rechargeBonus: 'Recharge Bonus',
    details: 'Event Details',
    activityTime: 'Activity Time',
    yourCurrentRecharge: 'Your Current Recharge',
    eventRewards: 'Event Rewards',
    rewardTable: {
      level: 'Level',
      bettingAmount: 'Betting Amount',
      bettingReward: 'Betting Reward',
    },
    cumuBets: 'Cumulative Bets',
    rechargeCount: 'Recharge Count',
    withdrawCount: 'Withdraw Count',
    prize: {
      ticket: 'Kerala lottery',
      spin: 'Lucky Spin',
    },
    type: {
      recharge: 'Recharge',
      withdraw: 'Withdraw',
      bet: 'Bet',
    },
    times: {
      1: '1st',
      2: '2nd',
      3: '3rd',
      4: '4th',
    },
    tip: {
      claim: 'Bet <0>{{amount}}</0> more to claim bonus',
      required: '<0>{{multiple}}</0> Betting Required',
      expired: 'The event has ended',
      withdraw: 'Withdraw immediately to earn',
      delete: 'Are you sure you want to delete this bonus?',
      deleteSuccess: 'Delete Successfully',
      toReceive:
        '{{type}} another <0>{{rechargeAmount}}</0> to receive a <0>{{bonusAmount}}</0> bonus',
      timeToReceive:
        '{{type}} another <0>{{rechargeAmount}}</0> more times to receive a <0>{{bonusAmount}}</0> bonus',
      completedRecharge: 'You have completed your {{times}} recharge',
      notCompleteRechargeTitle: '{{times}} Recharge',
      currentRechargeTitle: 'Your {{times}} Recharge',
      rechargeToGet: 'Recharge {{amountRange}} to get a reward of {{bonus}}',
      mustComplete:
        'You must complete the {{currentCount}} recharge to participate in the {{nextCount}} recharge event',
      notLogin: 'Please login to participate in this event',
    },
  },
  gameRules: {
    title: 'Game Rules',
    tableOfContents: 'TABLE OF CONTENTS:',
    menu: {
      generalTerms: 'GENERAL TERMS',
      specialTerms: 'SPECIAL TERMS',
      cricket: 'CRICKET',
      kabaddi: 'KABADDI',
      TENNIS: 'TENNIS',
      BASKETBALL: 'BASKETBALL',
      VOLLEYBALL: 'VOLLEYBALL',
      'BEACH VOLLEYBALL, TABLE TENNIS, BADMINTON': 'BEACH VOLLEYBALL',
      FOOTBALL: 'FOOTBALL',
      'E-SPORT': 'E-SPORTS',
    },
    generalTerms: {
      title: 'GENERAL TERMS',
      content:
        'The Special features of rules on different sports are an integral part of the T&C.',
      rule1:
        '1. The Special features of rules on different sports are an integral part of the T&C.',
      rule2:
        '2. The terms used in these Special features of rules on different sports have the same meanings as in the T&C. Observance of these Special features of rules on different sports is mandatory for the Clients and the Betting company. By making a bet, the Client confirms that he knows the current version of the Special features of rules on different sports, agrees with it and undertakes to strictly adhere to it.',
      rule3:
        '3. All bets are accepting in accordance with the T&C and these Special features of rules on different sports. In case of different regulation, rules implemented by The Special features of rules on different sports prevail.',
    },
    generalTerms1: {
      title: 'GENERAL TERMS',
      rule1:
        'The Special Features Of Rules On Different Sports Are An Integral Part Of The T&C.',
      rule2:
        'The Terms Used In These Special Features Of Rules On Different Sports Have The Same Meanings As In The T&C. Observance Of These Special Features Of Rules On Different Sports Is Mandatory For The Clients And The Betting Company. By',
    },
    // ... 其他规则部分
  },
  agent: {
    tabs: {
      agent: 'Agent',
      invitationReward: 'Invitation Reward',
      rules: 'Rules',
    },
    myTeam: {
      title: 'My Team',
      teamLevel: 'Team level',
      details: 'Details',
      teamSize: 'Team Size',
      teamRecharge: 'Team Recharge',
      myRebate: 'My rebate',
      betRebate: 'Bet rebate',
      rechargeRebate: 'Recharge rebate',
      upTo: 'up to',
      alreadyAchieved: 'Already achieved this rebate level',
      inviteFriends: 'Invite friends to get money',
    },
    rules: {
      // 代理等级说明
      agentLevelDescription: {
        title: 'Description of Agent Levels',
        level1: 'A -> You: A is your LV1 Refer',
        level2: 'B -> You: B is your LV2 Refer',
        level3: 'C -> You: C is your LV3 Refer',
        level4: 'D -> you: D is your LV4 Refer',
        description:
          'You can earn commission from your downline network up to 4 levels. Receive a percentage of all bets made by your referrals in Levels A, B, C and D. Check the below chart for detailed commission rates.',
      },
      // 佣金率
      commissionRate: {
        title: 'Commission rate',
        sportsRebates: 'Sports Rebates',
        casinoRebates: 'Casino Rebates',
        rechargeRebates: 'Recharge Rebates',
        agentLevel: 'Agent Level',
        level1: 'Level 1',
        level2: 'Level 2',
        level3: 'Level 3',
        level4: 'Level 4',
        gameTitle: 'Game Title',
        note: "Different games have different rebate rations. You can also increase the rebate ratio by upgrading your club's star rating.",
      },
      // 新表头与区块标题（国际化）
      tableHeaders: {
        rebateForBets: 'Rebate For Bets',
        teamLevel1: 'Team Level 1',
        teamLevel2: 'Team Level 2',
        teamLevel3: 'Team Level 3',
        teamLevel4: 'Team Level 4',
        clubStars: 'Club Stars',
        agentRequirements: 'Agent Requirements',
        rechargeRequired: 'Recharge Required',
      },
      sectionTitles: {
        sportRebates: 'Sport Rebates',
        casinoRebates: 'Casino Rebates',
        lotteryRebates: 'Lottery Rebates',
      },
      levelLabel: 'L{{level}}',
      // 俱乐部说明
      clubExplanation: {
        title: 'What is club?',
        description:
          'You and your downline referral are your club. Increase your downline referral to get higher star rating. Higher star, Higher commission',
        yourClub: 'Your Club',
      },
      // 星级提升要求
      starRatingRequirements: {
        title: 'How to Increase star Rating',
        starRating: 'Star Rating',
        referralRequired: 'Referral Required',
        bettingRequired: 'Betting Required',
        inviteNow: 'Invite Now!',
      },
      // FAQ
      faq: {
        title: 'FAQ',
        q1: 'Q1: What does commission split mean?',
        a1: 'A1: After inviting friends to join the application and bind your invitation code, you will receive additional commission based on the consumption of these friends at a certain ratio',
        q2: 'Q2: What does club mean?',
        a2: 'A2: Your club consists of all your agent team members',
        q3: 'Q3: How can I upgrade to a higher club star rating?',
        a3: 'A3: You can upgrade by inviting more friends or collectively consuming with team members. For more detailed information, please refer to the upgrade requirements table.',
        q4: 'Q4: How do I receive rewards?',
        a4: "A4: Once your friends or your friends' invitations make purchases, you will immediately receive all rewards, which will be deposited into your commission account and can be withdrawn to your wallet the next day",
        q5: 'Q5: Are there any wagering requirements for withdrawing rewards?',
        a5: 'A5: There is a one-time wagering requirement.',
        q6: 'Q6: When can I use my rewards?',
        a6: 'A6: You can withdraw your rewards to your wallet for spending the next day. Sometimes there may be slight delays. Thank you for your understanding',
      },
    },
    subordinateData: 'Subordinate Data',
    'level-cards': {
      'rebate-level': 'Rebate level',
      'team-size': 'Team Size',
    },
    searchText: 'Search',
    foundResults:
      'Found <span class="text-c1">{{count}}</span> results in the search.',
    'team-report': {
      title: 'Team Report',
      'user-id': 'User ID',
      user: 'Users',
      recharge: 'Recharge',
      betting: 'Betting',
      commission: 'Commission',
      'my-teams': 'My Teams',
      'new-user': 'New Users',
      'recharge-user': 'Recharge Users',
      'recharge-commission': 'Recharge Commission',
      'betting-commission': 'Betting Commission',
      'register-date': 'Register Date',
      tier: 'Tier {{tier}}',
      'search-text': "Enter subordinate's phone number",
      'search-min-chars': 'Please enter at least 3 characters',
      tabs: {
        today: 'Today',
        yesterday: 'Yesterday',
        '3days': '3Days',
        '7days': '7Days',
        '15days': '15Days',
        '30days': '30Days',
      },
    },
    'user-view': {
      title: 'User Details',
      upline: 'Up-Line',
      teamdata: 'Team Data',
      users: 'Users',
    },
    'invitation-reward': {
      newCustomerRewards: 'New Customer Rewards',
      taskConditions: 'Task Conditions',
      gear: 'Gear',
      rechargeAmount: 'Recharge amount',
      totalRewards: 'Total Rewards',
      totalInvites: 'Total Invites',
      saleRules: 'Sale Rules',
      inviteNewCustomersGet: 'Invite a new customers get',
      additionalRewards: 'Additional invitation rewards',
      myInvitationCode: 'My invitation code:',
    },
  },
  invitationReward: {
    newCustomerRewards: 'New Customer Rewards',
    totalInvites: 'Total Invites',
  },
  'withdraw-page': {
    label: {
      withdrawAmount: 'Withdraw Amount',
      received: 'Actual amount received:',
      recipientAddress: 'Recipient address:',
      receiveToken: 'Receive token:',
      transactionBreakdown: 'Transaction breakdown',
      exchangeRate: 'Real-Time Exchange Rate',
      exchangeRateTip:
        'Exchange rates fluctuate sharply. The above is for reference only; actual amount received prevails',
      processingFee: 'Processing Fee',
      selectCoin: 'Select Coin',
      estimatedUsdAmount: 'Estimated Withdrawal Amount',
    },
    error: {
      noWithdrawable: 'No withdrawable balance',
      addCard: 'Please add a bank card',
      addAmount: 'Please enter the withdrawal amount',
      selectCoin: 'Please select a coin',
      addAddress: 'Please enter the wallet address',
      invalidAddress: 'Invalid wallet address format',
      minAmount: 'Minimum withdrawal amount is {{amount}}',
      maxAmount: 'Maximum withdrawal amount is {{amount}}',
    },
    rules: {
      dailyLimit: 'Daily withdrawal limit',
      fees: 'Withdrawal fees',
      wager: 'Wager requirement',
      note1:
        'Note: withdraw may be delayed due to someBank issues. In this case, the withdrawn amount will be returned to your wallet. Thank you for your patience.',
      note2:
        'We have found some money laundry behaviorsSo limits that recharge amount should be used for betting only. The commission and winninoamount could be withdrawn immediately.',
      timesTitle: 'Daily withdrawal times',
    },
  },
  'recharge-page': {
    label: {
      exchangeRateTip:
        'Exchange rates fluctuate sharply. The above is for reference only; actual amount received prevails',
    },
  },
  rechargeGift: {
    title: 'Exclusive Recharge Gift',
    close: 'Close',
    getBonus: 'Get {{currency}} {{amount}} Bonus',
    tier: 'Gift Tier {{tier}}',
    rechargeAmount: 'Recharge amount',
    totalArrival: 'Total arrival',
    rechargeNow: 'Recharge now',
    progress: '{{current}} of {{total}} tiers completed',
    selectChannel: 'Recharge Channel',
    noChannel: 'No available recharge channel for this amount',
    confirmRecharge: 'Confirm {{currency}} {{amount}} recharge',
    confirm: 'Confirm',
    withdrawBadge: '24 Hours Withdrawal',
  },
};
